import { FormSelectYesNo } from '../../formelements'

/*
export const AuthSortides = ({auth, handleChange, error }) => 
{
  return (
      <div className="row">
      <div className="col col-12 ">
        <h4>
        Responsabilització sortides
        </h4>
        <p>
          <input type="checkbox" id="authSortides" name="authSortides" value={auth} checked={auth === "1" ? true : false } onChange={ (t) => { handleChange(t.target.value) } } required/>
          <label htmlFor="authSortides"> Em RESPONSABILITZO dels desplaçaments que faci pel meu compte cap/des de punts preestablerts en activitats i sortides del centre.  </label>
          <span id="auhtMaterial_ERROR" className="a-Form-error">{error}</span>
        </p>

      <br/>

      </div>
    </div>
    )
}
*/
                                  


export const AuthSortides = ({auth, handleChange, error }) => 
{
  return (
        <div className="row">
        <div className="col col-12 ">
          <h4>
          Autorització per a realitzar activitats fora del recinte escolar
          </h4>
          <p>
              Autoritzo a l'alumne/a matriculat/ada a participar a les activitats aprovades pel Consell Escolar del centre que es fan fora del recinte escolar, inclòs el desplaçament en transport públic
                o privat (autoritzat) segons les necessitats i condicionats de l'activitat. Així mateix faig extensiva aquesta autorització al professorat i a la direcció
                del centre perquè prengui les decisions medicoquirúrgiques que fossin necessàries en cas d'extrema urgència sota la pertinent direcció facultativa. 
                Període de validesa: aquesta autorització serà vàlida mentre l'alumne/a estigui matriculat en aquest centre. En cas que es vulgui anul·lar la seva validesa, caldrà 
                notificar-ho a secretaria.
          </p>

        <FormSelectYesNo
            id="authSortides"
            name="authSortides"
            col="col-6"
            label="Trieu una opció:"
            obligatori={true}
            value={auth}
            handleChange={(e) => handleChange(e.target.value) } 
            error={error}
            />

        </div>
      </div>
      )
}
